import { GetUsersApiParams, DeleteUserApiParams, InviteUserApiParams, UpdateUserRoleApiParams, InviteUserParams, GetUserPreferencesApiParams, UpdateUserPreferencesApiParams } from './types';
import { useCallback } from 'react';
import apiClient from '../axiosClient';

/**
 * @function useGetUsersApi
 * @returns { GetUsersApiParams }
 */
export function useGetUsersApi(): GetUsersApiParams {
  return useCallback((params) => apiClient.get(`/users`, {params}), []);
}

/**
 * @function useDeleteUserApi
 * @returns { DeleteUserApiParams }
 */
export function useDeleteUserApi(): DeleteUserApiParams {
  return useCallback((userId, companyId) => apiClient.delete(`/users/${userId}/detach-company`, {params: {companyId}}), []);
}

/**
 * @function useInviteUserApi
 * @returns { InviteUserApiParams }
 */
export function useInviteUserApi(): InviteUserApiParams {
  return useCallback((params: InviteUserParams[], companyId: string) => apiClient.post(`/users/invite`, params, {params: {companyId}}), []);
}

/**
 * @function useUpdateUserRoleApi
 * @returns { UpdateUserRoleApiParams }
 */
export function useUpdateUserRoleApi(): UpdateUserRoleApiParams {
  return useCallback((params, userId, companyId) => apiClient.put(`/users/${userId}/role`, params, {params: {companyId}}), []);
}

/**
 * @function useGetUserPreferencesApi
 * @returns { GetUserPreferencesApiParams }
 */
export function useGetUserPreferencesApi(): GetUserPreferencesApiParams {
  return useCallback((properties?: string[]) => apiClient.get(`/users/preferences`, {params: {properties}}), []);
}

/**
 * @function useUpdateUserPreferencesApi
 * @returns { UpdateUserPreferencesApiParams }
 */
export function useUpdateUserPreferencesApi(): UpdateUserPreferencesApiParams {
  return useCallback((preferences: Record<string, unknown>) => apiClient.put(`/users/preferences`, preferences), []);
}
